import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import { closeModal, openModal } from "../../redux/slices/uiSlice";
import { resendVerificationEmailAPI } from "../../api/auth";
import { clearEmailVerification } from "../../redux/slices/authSlice";
import { clearUser } from "../../redux/slices/userSlice";
import ModalWrapper from "./ModalWrapper";
import ResetImage from "../../assets/images/auth/reset-img.png";
import { useTranslation } from "react-i18next";
import useToast from "../../hooks/useToast";
import { logout } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import SecondaryBtn from "../button/SecondaryBtn";
import PrimaryBtn from "../button/PrimaryBtn";
interface VerifyEmailModalProps {
  email?: string | null;
}

const VerifyEmailModal: React.FC<VerifyEmailModalProps> = ({ email }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isResending, setIsResending] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => {
    logout();
    dispatch(clearUser());
    dispatch(clearEmailVerification());
    dispatch(closeModal());
    dispatch(openModal("login"));
  };

  const { mutate: resendEmail } = useMutation({
    mutationFn: resendVerificationEmailAPI,
    onSuccess: (data) => {
      useToast(t("verifyEmail.emailResentSuccess") || "Verification email resent successfully!", "success");
      setIsResending(false);
    },
    onError: (error: Error) => {
      useToast(error.message || t("verifyEmail.failedToResend") || "Failed to resend email", "error");
      setIsResending(false);
    },
  });

  const handleResend = () => {
    if (!email) {
      useToast(t("verifyEmail.emailRequired") || "Email is required", "error");
      return;
    }
    setIsResending(true);
    resendEmail(email);
  };

  if (!email) {
    return null;
  }

  const handleLogout = () => {
    logout();
    dispatch(clearUser());
    dispatch(clearEmailVerification());
    dispatch(closeModal());
    navigate("/");
    window.location.reload();
  };

  return (
    <ModalWrapper onClose={handleClose} showCloseButton disableBackdropClose>
      {/* Header */}
      <div className="text-center lg:mb-[0.6vw] mb-3">
        <h1 className="lg:text-[1.9vw]/[2.2vw] text-2xl/6 font-semibold text-primary-orange lg:mb-[0.3vw] mb-2">
          {t("verifyEmail.verifyEmail")}
        </h1>
        <p className="lg:text-[1.1vw]/[1.4vw] text-base/tight text-black-800 font-bold">
          {t("verifyEmail.checkVerificationLink")}
          <span className="text-primary-orange"> {email}</span> {t("verifyEmail.toVerifyEmail")}
        </p>
      </div>

      {/* Image */}
      <div className="lg:mb-[0.6vw] mb-3">
        <img
          src={ResetImage}
          alt="reset-img"
          className="mx-auto 2xl:w-[10.417vw] md:w-[130px] w-25 2xl:h-[10.417vw] md:h-[130px] h-25 object-contain"
        />
      </div>

      {/* <div className="text-center lg:my-[1.1vw] my-4">
        <span className="lg:text-[1.1vw]/[1.3vw] text-base/tight text-black-800 font-bold">
          {t("verifyEmail.didntGetLink")}
        </span>
      </div> */}

      {/* Resend Button */}
      <div className="flex justify-center gap-4">
        <PrimaryBtn
          onClick={handleResend}
          disabled={isResending}
        >
          {isResending ? t("verifyEmail.resending") || "Resending..." : t("verifyEmail.resendEmail") || "Resend Email"}
        </PrimaryBtn>
        <SecondaryBtn onClick={handleLogout} className="max-w-full">
          {t("mainHeader.logout")}
        </SecondaryBtn>
      </div>

    </ModalWrapper>
  );
};

export default VerifyEmailModal;
